import React, { lazy, Suspense } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { routesPath } from '@router/routes';
import { Layout } from '@components/Layout/Layout';
import { UserRoles } from '@dynamika-shared/types/auth';
import { WithUserRolesHoc } from '@components/HOC/WithUserRoles/WithUserRoles.hoc';
import { ReaderMenu } from '@components/Sidebar/Menu/ReaderMenu/ReaderMenu';
import { SiteUserLayout } from '@components/SiteUserLayout/SiteUserLayout';
import { SelectClinicalTrialForRole } from '@components/LoginSelections/SelectClinicalTrialForRole';
import { PageLoading } from '@dynamika-shared/ui/PageLoading/PageLoading';

const Readings = lazy(
  () => import('src/pages/Readings/ReadingsListPage/ReadingsListPage')
);
const ReadingTaskViewerPage = lazy(
  () => import('src/pages/Readings/ReadingTaskPage/ReadingTaskViewerPage')
);
const ReaderPlainForm = lazy(
  () => import('src/pages/Readings/ReadingTaskPage/ReaderPlainForm')
);
const ReadingTaskViewerPageDetached = lazy(
  () =>
    import('src/pages/Readings/ReadingTaskPage/ReadingTaskViewerPageDetached')
);

export const readerRoutes = [
  {
    path: routesPath.reader,
    element: (
      <WithUserRolesHoc allowedRoles={[UserRoles.READER]}>
        <SiteUserLayout>
          <SelectClinicalTrialForRole />
        </SiteUserLayout>
      </WithUserRolesHoc>
    ),
  },
  {
    path: routesPath.readerClinicalTrialReadings,
    element: (
      <Suspense fallback={<PageLoading className='h-full' />}>
        <Layout menuComponent={ReaderMenu}>
          <Readings />
        </Layout>
      </Suspense>
    ),
  },
  {
    path: routesPath.readerClinicalTrial,
    element: React.createElement(() => {
      const { id } = useParams();
      return (
        <Navigate
          to={routesPath.readerClinicalTrialReadings.replace(':id', id ?? '')}
        />
      );
    }),
  },
  {
    path: routesPath.readerTaskPage,
    element: React.createElement(() => {
      const segments = location.pathname.split('/');
      segments.pop();
      return <Navigate to={segments.join('/')} />;
    }),
  },
  {
    path: routesPath.readerSubTaskViewer,
    element: (
      <WithUserRolesHoc allowedRoles={[UserRoles.READER]}>
        <Suspense fallback={<PageLoading className='h-full' />}>
          <ReadingTaskViewerPage />
        </Suspense>
      </WithUserRolesHoc>
    ),
  },
  {
    path: routesPath.readerTaskViewer,
    element: (
      <WithUserRolesHoc allowedRoles={[UserRoles.READER]}>
        <Suspense fallback={<PageLoading className='h-full' />}>
          <ReadingTaskViewerPage />
        </Suspense>
      </WithUserRolesHoc>
    ),
  },
  {
    path: routesPath.readerTaskViewerDetached,
    element: (
      <WithUserRolesHoc allowedRoles={[UserRoles.READER]}>
        <Suspense fallback={<PageLoading className='h-full' />}>
          <ReadingTaskViewerPageDetached />
        </Suspense>
      </WithUserRolesHoc>
    ),
  },
  {
    path: routesPath.readerSubTaskViewerDetached,
    element: (
      <WithUserRolesHoc allowedRoles={[UserRoles.READER]}>
        <Suspense fallback={<PageLoading className='h-full' />}>
          <ReadingTaskViewerPageDetached />
        </Suspense>
      </WithUserRolesHoc>
    ),
  },

  {
    path: routesPath.readerTaskPlain,
    element: (
      <WithUserRolesHoc
        allowedRoles={[
          UserRoles.READER,
          UserRoles.PROJECT_MANAGER,
          UserRoles.SUPPORT,
          UserRoles.SPONSOR,
        ]}
      >
        <Suspense fallback={<PageLoading className='h-full' />}>
          <ReaderPlainForm />
        </Suspense>
      </WithUserRolesHoc>
    ),
  },
];
